import { fetchMandates } from '@qwealth/qdata';
import { useFetchOnMount } from '@qwealth/qcore';
import { useEffect, useState } from 'react';

export type MandateMap = Record<number, string>;

export default function useMandates(): MandateMap {
  const allMandates = useFetchOnMount(fetchMandates, [])(true);
  const [mandateMap, setMandateMap] = useState<MandateMap>({});

  useEffect(() => {
    if (allMandates && allMandates.length > 0) {
      const mandates: MandateMap = {};

      allMandates.forEach(mandate => {
        if (mandate.id && mandate.partnerMandateName) {
          mandates[mandate.id] = mandate.partnerMandateName;
        }
      });

      setMandateMap(mandates);
    }
  }, [allMandates]);

  return mandateMap;
}
